export default "__VITE_ASSET__CMGm6ed$__"